import Amplify, { Auth } from 'aws-amplify';
import { AccountService, HolderService, SessionService, TokenTraderService } from 'services';

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: true,
  },
});

function getCurrentUser() {
  return Auth.currentUserInfo();
}

async function signOut() {
  await Auth.signOut();
  await SessionService.signOut();
}

async function signUp({ username, password }) {
  return Auth.signUp({
    username,
    password,
    attributes: { website: window.location.hostname },
  });
}

async function confirmSignUp({ username, code }) {
  return Auth.confirmSignUp(username, code);
}

async function resendSignUp(username) {
  await Auth.resendSignUp(username);
}

async function signIn({ username, password }) {
  const auth = await Auth.signIn(username, password);
  if (auth && auth.challengeName === 'NEW_PASSWORD_REQUIRED') {
    throw new Error('PasswordResetRequired');
  }
  if (auth && auth.challengeName === 'SOFTWARE_TOKEN_MFA') {
    throw new Error('mfaEnabled');
  }
  const cognitoIdToken = await SessionService.getCognitoIdToken();
  const isAccountExists = await TokenTraderService.isAccountExists(cognitoIdToken);
  if (!isAccountExists) await TokenTraderService.createAccount(cognitoIdToken);
  await SessionService.getToken();
  const ssoID = SessionService.getUserSsoID();

  // if no account getAccount gets rejected then create it one
  await AccountService.getAccount()
    .then((account) => account)
    .catch(() => AccountService.createAccount(ssoID))
    .then((account) => account);

  // if holder with same email not found then is rejected
  const holder = await HolderService.getHolder();
  return holder;
}

async function SSOSignIn({ jwt }) {
  SessionService.setSessionStorage(jwt);
  return HolderService.getHolder();
}

async function forgotPassword(username) {
  await Auth.forgotPassword(username);
}

async function forgotPasswordConfirm({ username, code, password }) {
  return await Auth.forgotPasswordSubmit(username, code, password);
}

export default {
  getCurrentUser,
  signOut,
  signUp,
  confirmSignUp,
  resendSignUp,
  signIn,
  forgotPassword,
  forgotPasswordConfirm,
  SSOSignIn,
};
